<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <h1 class="pc_brand">Poppy</h1>
          <p class="text-center">
            KC registered Enhanced Five Generations Pedigree, Poppy. With multiple show champions in her pedigree , she
            has a perfect conformation ( physical structure, shape, and overall body makeup of the animal, including
            bone proportions, muscle tone, and angles of the joints). She is a perfect example of the miniature poodle
            breed measuring in at 14 inches to the withers. She possesses a strong athleticism and natural intellect.
            Easily trainable and eager to please. A sweetheart because as well as loving her humans’ attention she also
            enjoys to give other dogs puppy kisses. Possesses a lot of character.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <GalleryComponent :slides="poppySlideshowSlides" height="600"/>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import GalleryComponent from "@/components/GalleryComponent.vue";
import {mapState} from "vuex";

export default {
  name: 'PoppyView',
  components: {GalleryComponent},
  computed: mapState([
    'poppySlideshowSlides',
  ]),
  mounted() {
    this.$store.dispatch('createPoppySlideshowSlides');
  }
}
</script>
